//判断当前是否为生产环境
let isProd = process.env.NODE_ENV === "production";
//老旧的环境配置，已废弃，保留历史记录 
// const envMap = {
//     development: 'https://testqing.linghealth.cn',
//     // development:'https://jzgl.shdsyy.org.cn',
// };
//配合 vue.config.js 里的 devServer.proxy 代理转发 /api 请求到 https://testqing.ryndata.com
let BASE_URL = isProd ? window.location.origin : '';
//version与publicPath暂无测试与生产环境之分 
export default {
    BASE_URL,
    version: '001',
    //也许有天会切换到008版本 
    // version: '008',
    viewtypeFix: isProd ? "screen" : "window",
    isXp: checkOsXp(),
    maximage_cache_xp: 200 * 1024 * 1024,
    maximage_cache_win10: 512 * 1024 * 1024,
    wado_webworkers_xp: 1,
    // 下载安装包
    // DEV_SERVER: "192.168.2.135:7788",
    PRODUCTION_SERVER: isProd ? "" : "http://tj.sparkcab.com",
};

function checkOsXp() {
    let agent = navigator.userAgent;

    if (agent.indexOf("Windows NT 5") !== -1) {
        return true;
    } else if (agent.indexOf("Windows NT 7") !== -1) {
        return false;
    } else if (agent.indexOf("Windows NT 10") !== -1) {
        return false;
    } else {
        return false;
    }
}